// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPageableObject } from './IPageableObject';
import {
    IPageableObjectFromJSON,
    IPageableObjectFromJSONTyped,
    IPageableObjectToJSON,
    IPageableObjectToJSONTyped,
} from './IPageableObject';
import type { ISortOrder } from './ISortOrder';
import {
    ISortOrderFromJSON,
    ISortOrderFromJSONTyped,
    ISortOrderToJSON,
    ISortOrderToJSONTyped,
} from './ISortOrder';
import type { ITriggerDto } from './ITriggerDto';
import {
    ITriggerDtoFromJSON,
    ITriggerDtoFromJSONTyped,
    ITriggerDtoToJSON,
    ITriggerDtoToJSONTyped,
} from './ITriggerDto';

/**
 * 
 * @export
 * @interface IPageTriggerDto
 */
export interface IPageTriggerDto {
    /**
     * 
     * @type {number}
     * @memberof IPageTriggerDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageTriggerDto
     */
    total_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageTriggerDto
     */
    size?: number;
    /**
     * 
     * @type {Array<ITriggerDto>}
     * @memberof IPageTriggerDto
     */
    content?: Array<ITriggerDto>;
    /**
     * 
     * @type {number}
     * @memberof IPageTriggerDto
     */
    number?: number;
    /**
     * 
     * @type {Array<ISortOrder>}
     * @memberof IPageTriggerDto
     */
    sort?: Array<ISortOrder>;
    /**
     * 
     * @type {IPageableObject}
     * @memberof IPageTriggerDto
     */
    pageable?: IPageableObject;
    /**
     * 
     * @type {number}
     * @memberof IPageTriggerDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPageTriggerDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageTriggerDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageTriggerDto
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the IPageTriggerDto interface.
 */
export function instanceOfIPageTriggerDto(value: object): value is IPageTriggerDto {
    return true;
}

export function IPageTriggerDtoFromJSON(json: any): IPageTriggerDto {
    return IPageTriggerDtoFromJSONTyped(json, false);
}

export function IPageTriggerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPageTriggerDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
        'size': json['size'] == null ? undefined : json['size'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(ITriggerDtoFromJSON)),
        'number': json['number'] == null ? undefined : json['number'],
        'sort': json['sort'] == null ? undefined : ((json['sort'] as Array<any>).map(ISortOrderFromJSON)),
        'pageable': json['pageable'] == null ? undefined : IPageableObjectFromJSON(json['pageable']),
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function IPageTriggerDtoToJSON(json: any): IPageTriggerDto {
    return IPageTriggerDtoToJSONTyped(json, false);
}

export function IPageTriggerDtoToJSONTyped(value?: IPageTriggerDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPages': value['total_pages'],
        'totalElements': value['total_elements'],
        'size': value['size'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(ITriggerDtoToJSON)),
        'number': value['number'],
        'sort': value['sort'] == null ? undefined : ((value['sort'] as Array<any>).map(ISortOrderToJSON)),
        'pageable': IPageableObjectToJSON(value['pageable']),
        'numberOfElements': value['number_of_elements'],
        'first': value['first'],
        'last': value['last'],
        'empty': value['empty'],
    };
}

